var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--s-exchange",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3402 6.23602C20.5364 6.40482 20.6563 6.64439 20.6732 6.90132L21 11.8855L19.0585 12.0105L18.9011 9.60948L13.9997 16.1866C13.819 16.429 13.5343 16.5738 13.2301 16.5778C12.9259 16.5818 12.6374 16.4446 12.4502 16.207L9.57389 12.5545L5.42911 17L4 15.692L8.92184 10.4131C9.11555 10.2053 9.39161 10.0923 9.67685 10.1041C9.96209 10.1159 10.2277 10.2512 10.4033 10.4742L13.1958 14.0202L17.477 8.27525C17.5321 8.20134 17.5958 8.13748 17.6657 8.08403L15.0559 8.28089L14.9082 6.35885L19.6286 6.00278C19.8877 5.98324 20.1439 6.06723 20.3402 6.23602Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSExchange);
export default __webpack_public_path__ + "static/media/icon--s-exchange.a95f5e2293cef1f7098209d0892e7adc.svg";
export { ForwardRef as ReactComponent };